
const VixclickLayer = function(elBtnOpen, elBtnClose) {
    elBtnOpen = document.querySelectorAll('[data-click-open]');
    elBtnClose = document.querySelectorAll('[data-click-close]');

    elBtnOpen.forEach(el => {
        el.addEventListener('click', e => {
            e.target.getAttribute('data-click-open') === 'box_layer' && !e.target.classList.contains('show') ? e.target.classList.add('show') : e.target.classList.remove('show');
        });
    });


    elBtnClose.forEach(el => {
        el.addEventListener('click', function (e) {
            const el_prev = e.currentTarget.closest('.box_layer').previousElementSibling;
            if(el_prev.getAttribute('data-click-open') === 'box_layer') el_prev.classList.remove('show');
        });
    });
};
export default VixclickLayer;
